import { QuoteSortType } from "@/common/enum/partner-quote-sort";

import { PartnerQuoteDurationButtonGroup } from "../button-group/PartnerQuoteDurationButtonGroup";
import { PartnerQuoteCalendarButton } from "../button/PartnerQuoteCalendarButton";
import { PartnerQuoteSortDropdown } from "../dropdown/PartnerQuoteSortDropdown";
import { PartnerNameSearch } from "../search/PartnerNameSearch";
import { DurationDateText } from "../text/DurationDateText";
import { Body14Medium } from "../typography/Body14Medium";

interface Props {
  totalElements: number;
  searchPartnerName: string;
  partnerQuoteSortType: QuoteSortType;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSortChange: (sortType: QuoteSortType) => void;
}

export const PartnerQuoteBar: React.FC<Props> = ({
  totalElements,
  searchPartnerName,
  partnerQuoteSortType,
  handleSearchChange,
  handleSortChange,
}) => {
  return (
    <div className="flex justify-between items-center py-[8px]">
      <Body14Medium className="text-semantic-text-body">
        {totalElements}개의 견적 내역
      </Body14Medium>
      <div className="flex gap-[16px]">
        <PartnerNameSearch
          placeholder="파트너명 검색"
          keyword={searchPartnerName}
          handleSearchChange={handleSearchChange}
        />
        <PartnerQuoteDurationButtonGroup />
        <PartnerQuoteCalendarButton />
        <DurationDateText />
        <PartnerQuoteSortDropdown
          partnerQuoteSortType={partnerQuoteSortType}
          handleSortChange={handleSortChange}
        />
      </div>
    </div>
  );
};
